// extracted by mini-css-extract-plugin
export var heroSection = "index-module--heroSection--JFpi3";
export var heroCopy = "index-module--heroCopy--2pZg2";
export var heroPara = "index-module--heroPara--w994e";